import axios from "axios";

const postExamination = async (baseUrl, token, doctorId, appointmentId, examinationList) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let postResponse = null

    await axios.post(baseUrl + `/doctor/` + doctorId + "/appointment/" + appointmentId + "/examination", examinationList, config)
        .then((res) => {
            postResponse = {
                status: res.status,
                result: res.data.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                postResponse = {
                    status: error.response.status,
                    result:  error.response.status
                }
            }
        });
    return postResponse
}

export default postExamination;